(function () {
  var scriptSrc = document.currentScript && document.currentScript.src ? document.currentScript.src : "";

  function appendFinalNavCss() {
    if (document.getElementById("dpn-reseller-page-nav-final-v19")) return;

    var href = scriptSrc ? scriptSrc.replace(/\.js(\?.*)?$/, ".css$1") : "";

    if (!href) return;

    var link = document.createElement("link");
    link.id = "dpn-reseller-page-nav-final-v19";
    link.rel = "stylesheet";
    link.href = href + (href.indexOf("?") >= 0 ? "&" : "?") + "loaded=last&navfix=20260706v20";
    document.head.appendChild(link);
  }

  function ensureOfficialNavigation() {
    var nav = document.querySelector(".site-nav-menu");
    if (!nav) return;

    var vpnLink = nav.querySelector('a[href*="/collections/all"]');
    var howLink = nav.querySelector('a[href*="/pages/how-portable-vpn-router-works"]');
    var guideLink = nav.querySelector('a[href*="/pages/the-ultimate-guide-to-travel-vpn-routers"]');

    if (vpnLink) vpnLink.textContent = "VPN Router";
    if (howLink) howLink.textContent = "How it works";
    if (guideLink) guideLink.textContent = "Travel Privacy Guide";

    if (howLink && !nav.querySelector(".site-nav-link--dpn-app")) {
      var dpnAppLink = document.createElement("a");
      dpnAppLink.className = "site-nav-link site-nav-link--dpn-app";
      dpnAppLink.href = "https://dpn.deeper.network/download";
      dpnAppLink.target = "_blank";
      dpnAppLink.rel = "noopener";
      dpnAppLink.innerHTML = '<span>DPN APP</span><span class="site-nav-new-badge">New</span>';
      nav.insertBefore(dpnAppLink, howLink);
    }
  }

  function appendHeaderConsistencyCss() {
    var id = "dpn-reseller-header-consistency-runtime-v32";
    var style = document.getElementById(id);
    var source = document.getElementById("dpn-reseller-header-consistency-lock-v32");

    if (!source) return;

    if (!style) {
      style = document.createElement("style");
      style.id = id;
    }

    style.textContent = source.textContent;
    document.head.appendChild(style);
  }

  function updateHeaderBottom() {
    var header = document.querySelector(".site-header");
    var inner = document.querySelector(".site-header-inner");
    if (!header) return;

    var target = header.classList.contains("is-floating") && inner ? inner : header;
    document.documentElement.style.setProperty(
      "--reseller-header-bottom",
      Math.ceil(target.getBoundingClientRect().bottom) + "px"
    );
  }

  function normalizePublicUrl() {
    var url = new URL(window.location.href);
    var publicPath = "/pages/become-a-dpn-app-reseller";
    var sourcePaths = ["/pages/become-a-dpn-app-reseller-source-v38"];

    if (sourcePaths.indexOf(url.pathname) !== -1) {
      window.history.replaceState(null, "", publicPath + "?view=reseller" + url.hash);
    }
  }

  function run() {
    ensureOfficialNavigation();
    appendHeaderConsistencyCss();
    normalizePublicUrl();
    updateHeaderBottom();
    window.addEventListener("scroll", updateHeaderBottom, { passive: true });
    window.addEventListener("resize", updateHeaderBottom, { passive: true });
    window.setTimeout(function () {
      ensureOfficialNavigation();
      appendHeaderConsistencyCss();
    }, 300);
    window.setTimeout(function () {
      ensureOfficialNavigation();
      appendHeaderConsistencyCss();
      updateHeaderBottom();
    }, 1200);
    window.setTimeout(updateHeaderBottom, 60);
    window.setTimeout(updateHeaderBottom, 240);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
